import React, { useState, useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import appointmentDetailsAtom from '../atoms/appointmentDetailsAtom';
import { url } from '../utils/config';
import axios from 'axios';
import { toast } from 'react-toastify';
import arrowBlack from '../assets/icons/arrow_black.png';
import { inputStyleTwo } from '../utils/style';

const TIME_SLOTS = [
    '8:00 AM - 11:00 AM',
    '11:00 AM - 3:00 PM',
    '3:00 PM - 6:00 PM'
];

function EditAppointment({ setShowEditForm, getAppointments }) {
    const [appointmentDetails, setAppointmentDetails] = useRecoilState(appointmentDetailsAtom);
    console.log(appointmentDetails)
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        location: '',
        make: '',
        model: '',
        year: '',
        color: '',
        problemDescription: '',
        vehicleOperable: false
    });
    const [errors, setErrors] = useState({});
    const [changedFields, setChangedFields] = useState({});
    const [cars, setCars] = useState([])
    const locationInputRef = useRef(null);

    // Validation rules
    const validateField = (name, value) => {
        switch (name) {
            case 'date':
                if (!value) return 'Date is required';
                const selectedDate = new Date(value);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                if (selectedDate < today) return 'Date cannot be in the past';
                break;
            case 'time':
                if (!value) return 'Time slot is required';
                break;
            case 'location':
                if (!value.trim()) return 'Location is required';
                break;
            case 'make':
                if (!value.trim()) return 'Make is required';
                break;
            case 'model':
                if (!value.trim()) return 'Model is required';
                break;
            case 'year':
                if (!value) return 'Year is required';
                const yearNum = parseInt(value);
                const currentYear = new Date().getFullYear();
                if (yearNum < 1900 || yearNum > currentYear + 1) {
                    return `Year must be between 1900 and ${currentYear + 1}`;
                }
                break;
            case 'problemDescription':
                if (!value.trim()) return 'Problem description is required';
                if (value.trim().length < 10) return 'Problem description must be at least 10 characters';
                break;
            default:
                return '';
        }
    };

    const inputClassName = "w-full px-3 py-2 border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors";
    const labelClassName = "block text-sm font-medium text-gray-700 mb-1";

    // Validate all fields
    const validateForm = () => {
        const newErrors = {};
        Object.keys(formData).forEach(key => {
            if (['date', 'time', 'location', 'make', 'model', 'year', 'problemDescription'].includes(key)) {
                const error = validateField(key, formData[key]);
                if (error) newErrors[key] = error;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    console.log('Appointment Details:', appointmentDetails.date);
    // Convert MM-DD-YYYY to YYYY-MM-DD format
    const convertDateFormat = (dateString) => {
        if (!dateString) return '';
        const [month, day, year] = dateString.split('-');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    // Get minimum date from appointment date
    const getMinDate = () => {
        if (!appointmentDetails?.date) return '';
        return convertDateFormat(appointmentDetails.date);
    };

    useEffect(() => {
        if (appointmentDetails) {
            console.log('Appointment Date:', appointmentDetails.date); // Debug log
            console.log('Appointment Time:', appointmentDetails.time); // Debug log

            const formatDate = (dateString) => {
                if (!dateString) return '';

                // If the date is already in YYYY-MM-DD format, return it as is
                if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
                    return dateString;
                }

                // Convert MM-DD-YYYY to YYYY-MM-DD
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    const [month, day, year] = parts;
                    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                }
                return dateString; // Return original if format doesn't match
            };

            const formatTime = (timeString) => {
                if (!timeString) return '';

                // Clean up the time string
                const cleanTime = timeString.trim().toUpperCase();

                // If the time already matches one of the time slots exactly, return it
                if (TIME_SLOTS.includes(cleanTime)) {
                    return cleanTime;
                }

                // Try to match the time with the closest time slot
                for (const slot of TIME_SLOTS) {
                    const slotUpper = slot.toUpperCase();
                    // Check if the time is within the slot range
                    if (slotUpper.includes(cleanTime) || cleanTime.includes(slotUpper)) {
                        return slot;
                    }
                }

                // If no match found, try to find the closest time slot based on the time
                const time = cleanTime.split(' ')[0]; // Get just the time part (e.g., "8:00" from "8:00 AM")
                const [hours, minutes] = time.split(':').map(Number);
                const timeInMinutes = hours * 60 + minutes;

                // Find the closest time slot
                let closestSlot = TIME_SLOTS[0];
                let minDiff = Infinity;

                TIME_SLOTS.forEach(slot => {
                    const [startTime] = slot.split(' - ');
                    const [slotHours, slotMinutes] = startTime.split(':').map(Number);
                    const slotTimeInMinutes = slotHours * 60 + slotMinutes;
                    const diff = Math.abs(timeInMinutes - slotTimeInMinutes);

                    if (diff < minDiff) {
                        minDiff = diff;
                        closestSlot = slot;
                    }
                });

                return closestSlot;
            };

            setFormData({
                id: appointmentDetails.id,
                name: appointmentDetails.pilot_user?.name || '',
                email: appointmentDetails.pilot_user?.email || '',
                phone: appointmentDetails.pilot_user?.phone || '',
                date: formatDate(appointmentDetails.date),
                time: formatTime(appointmentDetails.time),
                location: appointmentDetails.location || '',
                make: appointmentDetails.make || '',
                model: appointmentDetails.model || '',
                year: appointmentDetails.year || '',
                color: appointmentDetails.color || '',
                problemDescription: appointmentDetails.problemDescription || '',
                vehicleOperable: appointmentDetails.vehicleOperable || false
            });
        }
    }, [appointmentDetails]);

    // Initialize Google Places Autocomplete
    useEffect(() => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        if (!apiKey) {
            console.error('Google Maps API key is missing');
            return;
        }

        if (window.google && locationInputRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(locationInputRef.current, {
                // componentRestrictions: { country: "us" },
                fields: ["address_components", "formatted_address", "geometry"],
                types: ["address"]
            });

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                const address = place.formatted_address;

                setFormData(prev => ({
                    ...prev,
                    location: address
                }));

                // Track changed field
                if (appointmentDetails.location !== address) {
                    setChangedFields(prev => ({
                        ...prev,
                        location: address
                    }));
                }
            });
        }
        fetchCars()
    }, []);

    async function fetchCars() {
        try {
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(url + '/cars', { headers })
            setCars(data.data)
        } catch (error) {
            console.log(error)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }

        // Track changed fields
        if (appointmentDetails[name] !== value) {
            setChangedFields(prev => ({
                ...prev,
                [name]: value
            }));
        } else {
            const { [name]: removed, ...rest } = changedFields;
            setChangedFields(rest);
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        const error = validateField(name, value);
        if (error) {
            setErrors(prev => ({
                ...prev,
                [name]: error
            }));
        }
    };

    function getMakeList() {
        const make = [];
        cars.forEach(car => {
            if (!make.includes(car.make)) {
                make.push(car.make)
            }
        })
        return make.sort();
    }

    function getModelList() {
        const model = []
        cars.filter(car => car.make === formData.make).forEach(car => { if (!model.includes(car.model)) model.push(car.model) });
        return model.sort();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form
        if (!validateForm()) {
            toast.error('Please fix the errors before submitting', { autoClose: 3000 });
            return;
        }

        // Check if any fields were actually changed
        if (Object.keys(changedFields).length === 0) {
            toast.info('No changes were made', { autoClose: 3000 });
            return;
        }

        try {
            const token = window.localStorage.getItem('token');
            if (!token) {
                toast.error('Authentication required', { autoClose: 3000 });
                return;
            }

            // Convert date back to MM-DD-YYYY format before sending
            const formattedChangedFields = { ...changedFields };
            if (formattedChangedFields.date) {
                const [year, month, day] = formattedChangedFields.date.split('-');
                formattedChangedFields.date = `${month}-${day}-${year}`;
            }

            const dataToSend = {
                id: appointmentDetails.id,
                ...formattedChangedFields
            };

            const response = await axios.patch(
                `${url}/booking`,
                dataToSend,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (response.status === 200) {
                toast.success('Appointment updated successfully', { autoClose: 3000 });
                await getAppointments();
                setShowEditForm(false);
                setAppointmentDetails(prev => ({
                    ...prev,
                    ...formattedChangedFields
                }));
            }
        } catch (error) {
            console.error('Update error:', error);
            toast.error(error?.response?.data?.message || 'Failed to update appointment', { autoClose: 3000 });
        }
    };

    return (
        <div className="h-full bg-gray-50">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b z-10 py-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <button
                            className="p-1.5 hover:bg-gray-100 rounded-full"
                            onClick={() => setShowEditForm(false)}
                        >
                            <img src={arrowBlack} className="w-5 h-5" alt="back" />
                        </button>
                        <h2 className="ml-2 text-base font-medium">Edit Appointment</h2>
                    </div>
                </div>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-3 space-y-3 pb-24">
                {/* Customer Info */}
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="text-xs text-gray-500 block mb-1">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                disabled={true}
                                // className={`${inputClassName} ${errors.name ? 'border-red-500' : ''} bg-gray-100`}
                                className="w-full text-sm p-2.5 border border-gray-200 rounded-lg bg-gray-50"
                            />
                        </div>
                        <div>
                            <label className="text-xs text-gray-500 block mb-1">Phone</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                disabled={true}
                                className="w-full text-sm p-2.5 border border-gray-200 rounded-lg bg-gray-50"
                            />
                        </div>
                    </div>
                    <div className="mt-3">
                        <label className="text-xs text-gray-500 block mb-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            disabled={true}
                            className="w-full text-sm p-2.5 border border-gray-200 rounded-lg bg-gray-50"
                        />
                    </div>
                </div>

                {/* Schedule & Location */}
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                            <label className="text-xs text-gray-500 block mb-1">Date *</label>
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                min={new Date().toISOString().split('T')[0]}
                                // min={getMinDate()}
                                className={`w-full text-sm p-2.5 border rounded-lg
                                    ${errors.date ? 'border-red-500' : 'border-gray-200'}`}
                            />
                            {errors.date && (
                                <p className="text-red-500 text-xs mt-1">{errors.date}</p>
                            )}
                        </div>
                        <div>
                            <label className="text-xs text-gray-500 block mb-1">Time *</label>
                            <select
                                name="time"
                                value={formData.time}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={`w-full text-sm p-2.5 border rounded-lg 
                                    ${errors.time ? 'border-red-500' : 'border-gray-200'}`}
                            >
                                <option value="">Select Time Slot</option>
                                {TIME_SLOTS.map((slot) => (
                                    <option key={slot} value={slot}>
                                        {slot}
                                    </option>
                                ))}
                            </select>
                            {errors.time && (
                                <p className="text-red-500 text-xs mt-1">{errors.time}</p>
                            )}
                        </div>
                    </div>
                    <div>
                        <label className="text-xs text-gray-500 block mb-1">Location *</label>
                        <input
                            ref={locationInputRef}
                            type="text"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Start typing an address..."
                            className={`w-full text-sm p-2.5 border rounded-lg  
                                ${errors.location ? 'border-red-500' : 'border-gray-200'}`}
                        />
                        {errors.location && (
                            <p className="text-red-500 text-xs mt-1">{errors.location}</p>
                        )}
                    </div>
                </div>

                {/* Vehicle Info */}
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div>
                            <label className="text-xs text-gray-500 block mb-1">Make *</label>
                            <select
                                onChange={handleChange}
                                className={inputStyleTwo}
                                name="make"
                                value={formData.make}
                                onBlur={handleBlur}
                                required
                            >
                                <option value={""}>--Select--</option>
                                {getMakeList().map((make, ind) => <option key={ind} value={make}>{make}</option>)}
                            </select>
                            {errors.make && (
                                <p className="text-red-500 text-xs mt-1">{errors.make}</p>
                            )}
                        </div>

                        <div className="md:col-span-2">
                            <label className="text-xs text-gray-500 block mb-1">Model *</label>
                            <select
                                onChange={handleChange}
                                className={inputStyleTwo}
                                name="model"
                                value={formData.model}
                                onBlur={handleBlur}
                                required
                            >
                                <option value={""}>--Select--</option>
                                {getModelList().map((make, ind) => <option key={ind} value={make}>{make}</option>)}
                            </select>
                            {errors.model && (
                                <p className="text-red-500 text-xs mt-1">{errors.model}</p>
                            )}
                        </div>
                        <div>
                            <label className="text-xs text-gray-500 block mb-1">Year *</label>
                            <select
                                onChange={handleChange}
                                className={inputStyleTwo}
                                name="year"
                                value={formData.year}
                                onBlur={handleBlur}
                                required
                            >
                                <option value={""}>--Select--</option>
                                {cars.filter(car => car.make === formData.make && car.model === formData.model).sort((a, b) => a.year - b.year).map((car, index) =>
                                    <option key={index} value={car.year}>{car.year}</option>)}
                            </select>
                            {errors.year && (
                                <p className="text-red-500 text-xs mt-1">{errors.year}</p>
                            )}
                        </div>
                        {/* <div>
                            <label className="text-xs text-gray-500 block mb-1">Color</label>
                            <input
                                type="text"
                                name="color"
                                value={formData.color}
                                onChange={handleChange}
                                className="w-full text-sm p-2.5 border border-gray-200 rounded-lg bg-gray-50"
                            />
                        </div> */}
                    </div>
                    {/* <div className="mt-3">
                        <label className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                name="vehicleOperable"
                                checked={formData.vehicleOperable}
                                onChange={handleChange}
                                className="rounded text-customOne"
                            />
                            <span className="text-sm text-gray-700">Vehicle is Operable</span>
                        </label>
                    </div> */}
                </div>

                {/* Problem Description */}
                <div className="bg-white p-3 rounded-lg shadow-sm">
                    <label className="text-xs text-gray-500 block mb-1">Problem Description *</label>
                    <textarea
                        name="problemDescription"
                        value={formData.problemDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        rows="3"
                        className={`w-full text-sm p-2.5 border rounded-lg
                            ${errors.problemDescription ? 'border-red-500' : 'border-gray-200'}`}
                    />
                    {errors.problemDescription && (
                        <p className="text-red-500 text-xs mt-1">{errors.problemDescription}</p>
                    )}
                </div>

                {/* Fixed Bottom Actions */}
                <div className="fixed bottom-0 left-0 right-0 bg-white p-3 border-t">
                    <div className="flex gap-3">
                        <button
                            type="submit"
                            className="flex-1 py-2.5 bg-customOne text-white rounded-md text-sm font-medium"
                        >
                            Save Changes
                        </button>
                        <button
                            type="button"
                            onClick={() => setShowEditForm(false)}
                            className="flex-1 py-2.5 bg-gray-100 text-gray-700 rounded-md text-sm font-medium"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default EditAppointment; 